import styled from 'styled-components';
import TextInput from '../../atoms/TextInput';
import Tag from '../../atoms/Tag';
import {HoverColor} from '../../Colors';

export default {
	Wrapper : styled.span`
        position : relative;
        display : inline-block;
    `,
	Tag : styled(Tag)`
        margin-right : 2px;
    `,
	TextInput : styled(TextInput).attrs({
		borderType : 'none'
    })`
        border-radius : 5px;
        border : none;
        padding : 0.5rem 1rem 0.5rem 1rem;
        &:hover{
            background-color : ${HoverColor};
        }
    `,
	ErrorText : styled.div`
        position : absolute;
        border : 1px solid black;
        bottom : 0;
        right : 0;
    `,
	Baloon : styled.div`
        position : relative;
        background-color : white;
        color :red;
        &:after{
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            right: 3px;
            bottom: 3px;
            border-style: solid;
            border-color: transparent transparent transparent #ef887e;
            border-width: 10px 0 10px 17.32px;
            transform: rotate(45deg);
        }
    `,
};